
import empty from '@/views/default/empty'
import SubcontractStockQuery from "@/views/consignment/SubcontractStockQuery"
import ConsignmentStockQuery from "@/views/consignment/ConsignmentStockQuery"
import ConsignmentSummaryReport from "@/views/consignment/ConsignmentSummaryReport"
import WeeklyGIDetailForThailand from "@/views/consignment/WeeklyGIDetailForThailand"
export default [
  {
    path: '/consignment',
    name: 'Consignment',
    component: empty,
    children: [
      {
        path: "subcontract-stock-query",
        name: "SUBCONTRACT_STOCK_QUERY",
        meta: { externalUrl: '/vue3/#/consignment/subcontract-stock-query', tag: "toVue3" },
        component: SubcontractStockQuery,
      }, {
        path: "stock-query",
        name: "CONSIGNMENT_STOCK_QUERY",
        meta: { externalUrl: '/vue3/#/consignment/stock-query', tag: "toVue3" },
        component: ConsignmentStockQuery,
      },
      {
        path: "summary-report",
        name: "CONSIGNMENT_SUMMARY_REPORT",
        meta: { externalUrl: '/vue3/#/consignment/summary-report', tag: "toVue3" },
        component: ConsignmentSummaryReport,
      },
      {
        path: "weekly-gi-detail-for-thailand",
        name: "CONSIGNMENT_WEEKLY_GI_DETAIL_FOR_THAILAND",
        meta: { externalUrl: '/vue3/#/consignment/weekly-gi-detail-for-thailand', tag: "toVue3" },
        component: WeeklyGIDetailForThailand,
      }
    ]
  }
]
